<template>
  <fieldset>
    <legend>
      <span class="pull-left">{{ $t('form.employment_details.legend') }}</span>
      <!-- <a class="fa fa-question-circle" @click="displayModal($event, 0)" /> -->
      <a
        class="pull-right"
        ref="collapseLink"
        data-toggle="collapse"
        href="#collapse_employment_details"
        role="button"
        aria-expanded="true"
        aria-controls="collapse_employment_details"
      >
        <span class="fa fa-angle-up"></span>
        <span class="fa fa-angle-down"></span>
      </a>
    </legend>

    <modal v-show="modals[0]" @close="$set(modals, 0, false)">
      <h2 slot="modal-header">{{ $t('form.employment_details.legend') }}</h2>
      <div slot="modal-body"></div>
    </modal>

    <div class="collapse show" id="collapse_employment_details" ref="collapseElement">
      <div class="form-group">
        <label for="employment_location">{{ $t('form.employment_details.location.label') }}</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            id="employment_location"
            :placeholder="$t('form.employment_details.location.placeholder')"
            v-model="employmentDetails.location"
            @invalid="expandContent($refs.collapseLink, $refs.collapseElement)"
            required
          />
          <div class="invalid-feedback">
            <invalid-cross></invalid-cross>
            <span>{{ $t('form.validation_error_message') }}</span>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label
          for="employment_starting_date"
        >{{ $t('form.employment_details.starting_date.label') }}</label>
        <div class="input-group mb-4">
          <datepicker
            id="employment_starting_date"
            input-class="datepicker"
            :language="datapickerLocale"
            v-model="employmentDetails.startingDate"
            :placeholder="$t('form.employment_details.starting_date.placeholder')"
            format="dd/MM/yy"
          ></datepicker>
          <div class="invalid-feedback">
            <invalid-cross></invalid-cross>
            <span>{{ $t('form.validation_error_message') }}</span>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { da } from "vuejs-datepicker/dist/locale";

export default {
  components: {
    Datepicker
  },
  data() {
    return {
      datapickerLocale: da,
      employmentDetails: {
        location: "",
        startingDate: "",
        endingDate: "",
        indefintie: false,
        temporary: false
      }
    };
  },
  watch: {
    employmentDetails: {
      handler() {
        this.$store.commit("updateEmploymentDetails", this.employmentDetails);
      },
      deep: true
    }
  }
};
</script>
